<template>
	<el-card>
		<div slot="header">
			<span class="top_title">应收报表</span>
		</div>
		<div class="searchItem">
			<div class="search">
				<span class="searchtips">日期:</span>
				<el-date-picker
					v-model="search.daterange"
					type="datetimerange"
					:picker-options="pickerOptions"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					style="width: 230px"
					format="yyyy-MM-dd HH:mm"
					value-format="yyyy-MM-dd HH:mm"
				>
				</el-date-picker>
			</div>
			<div class="search">
				<span class="searchtips">客户分类:</span>
				<el-select ref="selectReport" :value="search.category" clearable @clear="clear" placeholder="自定义分类" style="width:180px">
					<el-option hidden :key="search.category" :value="search.category" :label="search.categoryName"></el-option>
					<el-tree default-expand-all :data="category" node-key="id" @node-click="handleNodeClick" />
				</el-select>
			</div>
			<Customer :orderForm="search" :hideStar='true'></Customer>
			<div class="search">
				<span class="searchtips">应收大于0:</span>
				<el-switch
					v-model="search.showType"
					:active-value="true"
					:inactive-value="false"
				/>
			</div>
			<div class="search">
				<el-button type="primary" @click="searchData" icon="el-icon-search">查询</el-button>
			</div>
			<div class="search">
				<el-button
					type="primary"
					icon="el-icon-printer"
					@click="print"
					v-if="$common.checkWindowsEnv()"
					>打印</el-button>
				<el-button
					type='primary'
					icon="el-icon-document"
					@click="changePdf"
				>导出</el-button>
			</div>
		</div>
		<el-table :data="tableData" style="width: 100%" :summary-method="getSummaries" show-summary border v-loading="loading">
			<template v-for="(col, index) in cols">
				<el-table-column 
					:key="index"
					:prop="col.prop" 
					:label="col.label" 
					:width="col.width"
					:min-width="col.min_width"
					align="left"
				>
					<template #header v-if="col.column">
						{{col.label}}
						<el-button circle icon="el-icon-top" size="mini" v-if="search.column==col.column&&search.order==true" type="primary" @click="setSort(col.column,true)"></el-button>
						<el-button circle icon="el-icon-top" size="mini" v-else @click="setSort(col.column,true)"></el-button>
						<el-button circle icon="el-icon-bottom" size="mini" v-if="search.column==col.column&&search.order==false" type="primary" @click="setSort(col.column,false)"></el-button>
						<el-button circle icon="el-icon-bottom" size="mini" v-else @click="setSort(col.column,false)"></el-button>
					</template>
					<template slot-scope="{ row }">
						<template v-if="col.type=='custype'">
							<template>
								<span style="color:#409EFF;cursor: pointer;" @click="showDetail(row.cid,row.cname)">[{{row.cnumber}}]{{row.cname}}</span>
							</template>
						</template>
						<template v-else-if="col.type=='catetype'">
							<template>
								<div>{{row.category.join(' ')}}</div>
							</template>
						</template>
						<template v-else>
							<div>{{row[col.prop]}}</div>
						</template>
					</template>
				</el-table-column>
			</template>
		</el-table>
		<el-pagination  style="text-align: right;padding-top:22px"
		:page-sizes="limits" :page-size="limit" 
		layout="total, sizes, prev, pager, next, jumper" 
		:total="maxCount" @size-change="handleSizeChange" 
		@current-change="handleCurrentChange" :pager-count="5"/>
		<ReportOrder ref="roder"></ReportOrder>
        <edit-share ref="share"></edit-share>
	</el-card>
</template>

<script>
import ReportOrder from '@/components/printshare/reportorder.vue';
import editShare from '@/components/printshare/edit_share';
import Customer from '@/components/customer'
	export default {
		components: {Customer,editShare,ReportOrder},
		data() {
			return {
				loading: true,
				category: [],
				maxCount:0,
				sumBeginbill: 0,
				sumFree: 0,
				sumNeedPay: 0,
				sumPayed: 0,
				sumTotal: 0,
				pickerOptions: {shortcuts:this.$common.initPickerOptions()},
				search: {
					cid: '',
					category: '',
					categoryName: '',
					showType:true,
					cname:' ',
					daterange:[],
					column:'',
					order:'',
				},
				tableData: [],
				current: 1,
				limit: 20,
				limits: [20, 50, 120, 250],
				searchObj:{
					page:1,
					limit:20,
					showown:1,
				},
				cols:[
					{
						label:'客户',
						prop:'',
						type:'custype',
						min_width:'180',
						column:'cnumber'
					},{
						label:'客户分类',
						prop:'',
						width:'100',
						type:'catetype',
					},{
						label:'期初(元)',
						prop:'beginbill',
						width:'160',
						column:'beginbill'
					},{
						label:'总金额(元)',
						prop:'total',
						width:'160',
						column:'total'
					},{
						label:'收款(元)',
						prop:'pay',
						width:'160',
						column:'pay'
					},{
						label:'免除(元)',
						prop:'free',
						width:'160',
						column:'free'
					},{
						label:'应收(元)',
						prop:'needPay',
						width:'160',
						column:'needpay'
					},
				]
			}
		},
		mounted() {
			this.getCategory()
			this.getData()
		},
		methods: {
			print(){
				let array = [];
				let cmp = this.$global.cmpId.cmp;
				array.push(cmp);
				this.$nextTick(()=>{
					this.$refs.roder.extraOpen(5,array);
				})
			},
			changePdf(){
				let array = [1];
				this.$nextTick(()=>{
					this.$refs.share.openList(array,5,this.searchObj);
				})
			},
			handleSizeChange(val) {
				this.limit = val;
				this.searchData();
			},
			handleCurrentChange(val) {
				this.current = val;
				this.searchObj.page = val;
				this.getData();
			},
			searchData(){
				this.current=1;
				this.searchObj = {
					page:this.current,
					limit:this.limit,
					cids:this.search.cid,
					cucids:this.search.category,
					showown:this.search.showType?1:'',
				}
				if(this.search.daterange&&this.search.daterange[1]){
					this.searchObj.start = this.search.daterange[0];
					this.searchObj.end = this.search.daterange[1];
				}
				this.sortTime();
			},
			setSort(column,order){
				if(this.search.column==column&&this.search.order==order){
					this.search.column = '';
					this.search.order = '';
				}else{
					this.search.column = column;
					this.search.order = order;
				}
				this.sortTime();
			},
			sortTime(){
				if(this.search.column){
					this.searchObj.column = this.search.column;
					this.searchObj.order = this.search.order?'asc':'desc';
				}else{
					delete this.searchObj.column;
					delete this.searchObj.order;
				}
				this.getData();
			},
			getCategory() {
				this.$api.customergetCustomerClassify({}).then(res => {
					this.category = res.data.data;
				}, () => {})
			},
			clear() {
				this.search.category = ''
				this.search.categoryName = ''
			},
			handleNodeClick(node) {
				this.search.category = node.id
				this.search.categoryName = node.label
				this.$refs.selectReport.blur()
			},
			getData(){
				this.loading=true
				this.$api.getNeedPayment(this.searchObj).then(res=>{
					var val = res.data.data;
					this.tableData=val.data;
					this.maxCount=val.total;
					this.sumBeginbill=val.sumBeginbill?val.sumBeginbill:0;
					this.sumFree=val.sumFree?val.sumFree:0;
					this.sumNeedPay=val.sumNeedPay?val.sumNeedPay:0;
					this.sumPayed=val.sumPayed?val.sumPayed:0;
					this.sumTotal=val.sumTotal?val.sumTotal:0;
					this.loading=false;
				},()=>{
					this.loading=false;
				})
			},
			getSummaries(){
				const sums = [];
				sums[0] = "合计";
				sums[1] = "";
				sums[2] = this.sumBeginbill;
				sums[3] = this.sumTotal;
				sums[4] = this.sumPayed;
				sums[5] = this.sumFree;
				sums[6] = this.sumNeedPay;
				return sums
			},
			showDetail(val,name){
				this.$router.push({ 
					path: "/customReport",
					query:{cid:val,cname:name},
				})
			}
		}
	}
</script>